<template functional>
  <div v-if="props.address">
    <div>{{ props.address.street }}</div>
    <div>
      {{ props.address.zipcode }} - {{ props.address.city }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasicAddress',
  props: {
    address: {
      type: Object,
      default: undefined
    }
  }
}
</script>
